<template>
  <div class="boxes">
    <div
      v-if="progressBox"
      class="col-auto col-md-auto col-lg-auto p-1 skeleton-container"
    >
      <PuSkeleton :duration="duration" height="25px" width="194px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="5px" width="120px"></PuSkeleton>
    </div>
    <div
      v-for="index in boxes"
      :key="index"
      class="col-auto col-md-auto col-lg-auto p-1 skeleton-container"
    >
      <PuSkeleton :duration="duration" height="25px" width="180px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
    </div>
    <!-- <div class="col-6 col-md-4 col-lg-auto p-1 skeleton-container">
      <PuSkeleton :duration="duration" height="25px" width="180px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
    </div>
    <div class="col-4 col-lg-auto p-1 skeleton-container">
      <PuSkeleton :duration="duration" height="25px" width="180px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
    </div>
    <div class="col-4 col-lg-auto p-1 skeleton-container">
      <PuSkeleton :duration="duration" height="25px" width="180px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
    </div>
    <div class="col-4 col-lg-auto p-1 skeleton-container">
      <PuSkeleton :duration="duration" height="25px" width="180px"></PuSkeleton>
      <PuSkeleton :duration="duration" height="25px" width="100px"></PuSkeleton>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "skeleton-boxes",
  props: {
    progressBox: {
      type: Boolean,
      default: false
    },
    boxes: {
      type: Number,
      default: 6
    },
    duration: {
      type: Number,
      default: 1.5
    }
  }
};
</script>

<style></style>
